'use strict';

const processInclude = require('base/util');

$(document).ready(function () {
  processInclude(require('./registration/registration'));
  processInclude(require('core/datepicker'));
  processInclude(require('tealium/tealiumEvents'));

  // Revamp-specific profileSFSC extension
  processInclude(require('./profile/profileSFSC'));

  // Wrap datepicker controls prev and next arrows in a wrapper div
  const inputElement = document.querySelector('.form-control__input--date');

  if (inputElement && inputElement.datepicker) {

    const pickerEl = inputElement.datepicker.picker.element;

    const prevBtn = pickerEl.querySelector('.prev-btn');
    const nextBtn = pickerEl.querySelector('.next-btn');
    const controls = pickerEl.querySelector('.datepicker-controls');

    if (prevBtn && nextBtn && controls) {
      prevBtn.innerHTML = "";
      nextBtn.innerHTML = "";

      const arrowsDivLeft = document.createElement('div');
      arrowsDivLeft.classList.add('prev-btn-wrapper');

      const arrowsDivRight = document.createElement('div');
      arrowsDivRight.classList.add('next-btn-wrapper');

      controls.insertBefore(arrowsDivLeft, prevBtn);
      controls.insertBefore(arrowsDivRight, nextBtn);

      arrowsDivLeft.appendChild(prevBtn);
      arrowsDivRight.appendChild(nextBtn);
    }
  }

});
require('core/components/spinner');
